<!--操作记录 operateRecords-->
<template>
  <div class="myoperateRecord" style="padding: 10px;">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>对象：</span>
              <el-input v-model="userName" type="text" class="numberInput" autocomplete="off"
                placeholder="请输入对象"></el-input>
            </div>
            <div class="input-small mr-20">
              <span>类型：</span>
              <el-select v-model="noticeType" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small ">
              <span>日期：</span>
              <el-date-picker v-model="dataTime" type="date" placeholder="选择日期"></el-date-picker>
            </div>
            <el-button type="primary" plain @click="search" class="search-btn">查询</el-button>
            <el-button type="primary" size="mini" @click="exportList">导出</el-button>

          </div>
        </el-scrollbar>
      </div>

      <div class="mytable" :style="{'height':heights+'px'}">
        <el-table :data="dataList" :height="heights - 20" border style="width: 100%;" stripe>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="90" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="noticeType" label="记录类型" :formatter="noticeTypeFormatter">
          </el-table-column>
          <el-table-column prop="createName" label="操作人">
          </el-table-column>
          <el-table-column prop="userName" label="对象">
          </el-table-column>
          <el-table-column prop="content" label="记录内容">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" :formatter="dataTimeFormatter">
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
      <RefundDialog ref="refundDialog"></RefundDialog>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>
  </div>
</template>

<script>
  import datePicker from '@/components/module/universal/datePicker.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import infoListMultipleSelection from './infoListMultipleSelection.vue'
  import RefundDialog from './dialogs/RefundDialog.vue'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  export default {
    components: {
      datePicker,
      singleSelection,
      infoListMultipleSelection,
      RefundDialog,
      elPagination,
      downloadTable
    },
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-240,
        dataList: [{createTime: 1715490573e3,pkid: 333153683374081,title: "充值通知",content: "微信充值1000.00元",createId: "d5040bbd2c3445179038edee58f8b24e",createName: "麦当劳",noticeClass: 0,noticeType: 1,state: 1,tag: "333153656668161",userName: "麦当劳",id: "333153683374081",entityName: "BaseNotice"},{createTime: 1715489634e3,pkid: 333151761076225,title: "充值通知",content: "微信充值500.00元",createId: "b949fda123424d7db29252fb70b924be",createName: "蜜雪冰城",noticeClass: 0,noticeType: 1,state: 1,tag: "333151748751361",userName: "蜜雪冰城",id: "333151761076225",entityName: "BaseNotice"},{createTime: 171543432e4,pkid: 333038478153729,title: "充值通知",content: "微信充值500.00元",createId: "274e1fab11824abebfba5f97b14966f5",createName: "九木杂物社",noticeClass: 0,noticeType: 1,state: 1,tag: "333038465445889",userName: "九木杂物社",id: "333038478153729",entityName: "BaseNotice"},{createTime: 1715434309e3,pkid: 333038455851009,title: "充值通知",content: "微信充值500.00元",createId: "274e1fab11824abebfba5f97b14966f5",createName: "九木杂物社",noticeClass: 0,noticeType: 1,state: 1,tag: "333038432776193",userName: "九木杂物社",id: "333038455851009",entityName: "BaseNotice"},{createTime: 1715414287e3,pkid: 332997450444801,title: "充值通知",content: "微信充值500.00元",createId: "0b3a7410b9d04608bd8c2c49b1b36512",createName: "RDD",noticeClass: 0,noticeType: 1,state: 1,tag: "332997437534209",userName: "RDD",id: "332997450444801",entityName: "BaseNotice"},{createTime: 1715397658e3,pkid: 332963394938881,title: "充值通知",content: "微信充值2000.00元",createId: "4d45d87fdc864c37a137f923af0f3b29",createName: "太阪町餐车",noticeClass: 0,noticeType: 1,state: 1,tag: "332963381364737",userName: "太阪町餐车",id: "332963394938881",entityName: "BaseNotice"},{createTime: 1715397581e3,pkid: 332963236435969,title: "充值通知",content: "微信充值1000.00元",createId: "c457e55b581f46b7a2c0e0c747b7c486",createName: "咪味的茶",noticeClass: 0,noticeType: 1,state: 1,tag: "332963207743489",userName: "咪味的茶",id: "332963236435969",entityName: "BaseNotice"},{createTime: 1715338479e3,pkid: 332842195617793,title: "充值通知",content: "微信充值5000.00元",createId: "a935088f35664e3ba95f96ced3a196f6",createName: "olas",noticeClass: 0,noticeType: 1,state: 1,tag: "332842172405761",userName: "olas",id: "332842195617793",entityName: "BaseNotice"},{createTime: 171533846e4,pkid: 332842157236225,title: "充值通知",content: "微信充值5000.00元",createId: "a935088f35664e3ba95f96ced3a196f6",createName: "olas",noticeClass: 0,noticeType: 1,state: 1,tag: "332842135201793",userName: "olas",id: "332842157236225",entityName: "BaseNotice"},{createTime: 1715323647e3,pkid: 332811819204609,title: "充值通知",content: "微信充值4000.00元",createId: "caad8ee3d871492188b90298f468dc0d",createName: "老饕小馆",noticeClass: 0,noticeType: 1,state: 1,tag: "332811802775553",userName: "老饕小馆",id: "332811819204609",entityName: "BaseNotice"},{createTime: 1715259787e3,pkid: 332681035085825,title: "充值通知",content: "微信充值500.00元",createId: "84b79a80221a4e3db89135fc3a8db767",createName: "回力",noticeClass: 0,noticeType: 1,state: 1,tag: "332681023739905",userName: "回力",id: "332681035085825",entityName: "BaseNotice"},{createTime: 1715255506e3,pkid: 332672266311681,title: "充值通知",content: "微信充值500.00元",createId: "84b79a80221a4e3db89135fc3a8db767",createName: "回力",noticeClass: 0,noticeType: 1,state: 1,tag: "332672250591233",userName: "回力",id: "332672266311681",entityName: "BaseNotice"},{createTime: 1715254205e3,pkid: 332669602992129,title: "充值通知",content: "微信充值3000.00元",createId: "b286d64a5d034b3a98bad3f2158f1377",createName: "东邪",noticeClass: 0,noticeType: 1,state: 1,tag: "332669583437825",userName: "东邪",id: "332669602992129",entityName: "BaseNotice"},{createTime: 1715226376e3,pkid: 332612608333825,title: "充值通知",content: "现金充值10000.00元",createId: "480b7e86a896472384fd9138806db532",createName: "1",noticeClass: 0,noticeType: 1,state: 1,tag: "332612608301057",userName: "喜市多",id: "332612608333825",entityName: "BaseNotice"},{createTime: 1715226255e3,pkid: 332612360794113,title: "充值通知",content: "现金充值2000.00元",createId: "480b7e86a896472384fd9138806db532",createName: "1",noticeClass: 0,noticeType: 1,state: 1,tag: "332612360536065",userName: "MARC JACOBS",id: "332612360794113",entityName: "BaseNotice"},{createTime: 1715221023e3,pkid: 332601645985793,title: "充值通知",content: "微信充值1000.00元",createId: "d5040bbd2c3445179038edee58f8b24e",createName: "麦当劳",noticeClass: 0,noticeType: 1,state: 1,tag: "332601633759233",userName: "麦当劳",id: "332601645985793",entityName: "BaseNotice"},{createTime: 1715160616e3,pkid: 332477933344769,title: "充值通知",content: "现金充值5000.00元",createId: "480b7e86a896472384fd9138806db532",createName: "1",noticeClass: 0,noticeType: 1,state: 1,tag: "332477933058049",userName: "太平洋咖啡",id: "332477933344769",entityName: "BaseNotice"},{createTime: 1715049628e3,pkid: 332250629873665,title: "充值通知",content: "现金充值6000.00元",createId: "480b7e86a896472384fd9138806db532",createName: "1",noticeClass: 0,noticeType: 1,state: 1,tag: "332250629677057",userName: "多乐之日",id: "332250629873665",entityName: "BaseNotice"},{createTime: 1715048951e3,pkid: 332249242849281,title: "充值通知",content: "微信充值1000.00元",createId: "d5040bbd2c3445179038edee58f8b24e",createName: "麦当劳",noticeClass: 0,noticeType: 1,state: 1,tag: "332249218091009",userName: "麦当劳",id: "332249242849281",entityName: "BaseNotice"},{createTime: 1715047928e3,pkid: 332247147741185,title: "充值通知",content: "微信充值500.00元",createId: "b949fda123424d7db29252fb70b924be",createName: "蜜雪冰城",noticeClass: 0,noticeType: 1,state: 1,tag: "332247135332353",userName: "蜜雪冰城",id: "332247147741185",entityName: "BaseNotice"}],
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        dataTime: '',
        userName: '',
        filterTime: false,
        searchChange: false,
        noticeClass: 0,
        noticeType: '',
        loading: false,//加载
        typeList: [{
          label: '催缴',
          value: 0
        },{
          label: '充值',
          value: 1
        },{
          label: '退费',
          value: 2
        },{
          label: '扣费',
          value: 3
        },{
          label: '拉闸',
          value: 4
        },{
          label: '合闸',
          value: 5
        },{
          label: '开户',
          value: 6
        },{
          label: '销户',
          value: 7
        },{
          label: '全部',
          value: ''
        }],
      }
    },

    mounted () {
      this.search()
    },

    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getOperateRecordsTimeInterval
      },
    },
    watch: {
      nowUnit () {
        this.search()
      },
    },
    methods: {
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,[],year+"-"+month+"-"+day+'-操作记录','.mytable')
      },
      search () {
        // console.log("搜索");
        var beginTime=''
        var endTime=''
        if(!isempty(this.dataTime)) {
          let dataTime=new Date(this.dataTime).format('yyyy-MM-dd')
          beginTime=new Date(dataTime+' 00:00:00').getTime()
          endTime=new Date(dataTime+' 23:59:59').getTime()
        }
        this.loading=true
        this.$api.noticeApi.getUnitNoticeLimit(this.nowUnit.id,this.pageIndex,this.pageSize,this.noticeClass,this.noticeType,beginTime,endTime,this.userName,respon => {
          this.loading=false
          this.dataList=respon.dataList
          this.total=respon.total
        },err => {
          this.$message.error(err);
          this.loading=false
        })
      },
      backout (item) {
        this.$refs.refundDialog.open(result => {
          this.$api.meterReadingApi.refund(item.id,result.fee,result.password,respon => {
            this.$message({
              message: respon,
              type: 'success'
            })
            this.search()
          },err => {
            this.$message.error(err);
          })
        })
      },
      // 批量导出
      exportReport () {
        var beginTime=this.filterTime? this.nowTimeInterval.startDate.getTime():undefined
        var endTime=this.filterTime? this.nowTimeInterval.endDate.getTime():undefined
        var title=this.nowUnit.name+'操作记录信息'
        this.$store.cacheStore.state.load=true
        this.$api.noticeApi.exportUnitNotice(this.nowUnit.id,this.noticeClass,this.noticeType,beginTime,endTime,this.userName,respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
          this.$store.cacheStore.state.load=false
        },err => {
          this.$store.cacheStore.state.load=false
          this.$dialogMethod.showMessage(err)
        })
      },
      noticeTypeFormatter (row,column) {
        //记录类型格式化
        return this.typeList[row.noticeType].label
      },
      dataTimeFormatter (row,column) {
        //格式化日期
        return new Date(row.createTime).format("yyyy-MM-dd hh:mm:ss")
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },

    }
  }
</script>

<style scoped lang="scss">
  .myoperateRecord {
    .con {
      width: 100%;
      height: 100%;
      padding: 12px 20px;
      background-color: #fff;
      box-sizing: border-box;

    }

    .search-input-btn {
      margin-top: 0px;
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }
</style>